var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrReceive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14785_6621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7247 12.8232C20.1357 13.2345 20.8022 13.2345 21.2131 12.8232L25.4237 8.61254C25.8227 8.19968 25.8169 7.5432 25.411 7.1369C25.0047 6.73098 24.3482 6.7252 23.9354 7.12418L21.5215 9.5377V1.55276C21.5215 0.971448 21.0504 0.5 20.4691 0.5C19.8878 0.5 19.4163 0.971448 19.4163 1.55276V9.5377L17.0028 7.12418C16.5896 6.7252 15.9331 6.73098 15.5272 7.1369C15.1209 7.5432 15.1155 8.19968 15.5141 8.61254L19.7247 12.8232Z",
    fill: "#73007D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4054 16.2717C39.405 16.0709 39.3464 15.8739 39.2369 15.7054L35.0263 9.38965C34.8312 9.09707 34.5028 8.92128 34.1509 8.9209H29.9406C29.3593 8.9209 28.8878 9.39235 28.8878 9.97366C28.8878 10.555 29.3593 11.0264 29.9406 11.0264H33.5877L36.3952 15.2367H4.53865L7.34576 11.0264H10.9932C11.5745 11.0264 12.0456 10.555 12.0456 9.97366C12.0456 9.39235 11.5745 8.9209 10.9932 8.9209H6.78256C6.43061 8.9209 6.10218 9.09707 5.90674 9.38965L1.69608 15.7054C1.58661 15.8739 1.52801 16.0709 1.52801 16.2717L1.51953 16.2894V39.4475C1.51953 40.0288 1.99059 40.4998 2.57191 40.4998H38.3615C38.9428 40.4998 39.4143 40.0288 39.4143 39.4475V16.2894L39.4054 16.2717ZM34.1509 36.2896H32.0457C31.4644 36.2896 30.993 35.8181 30.993 35.2368C30.993 34.6555 31.4644 34.1841 32.0457 34.1841H34.1509C34.7322 34.1841 35.2036 34.6555 35.2036 35.2368C35.2036 35.8181 34.7322 36.2896 34.1509 36.2896Z",
    fill: "#73007D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14785_6621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrReceive);
export default __webpack_public_path__ + "static/media/dr_receive.9f9a6d984ac333e5c997acb9988db16f.svg";
export { ForwardRef as ReactComponent };